<template>
    <div>
        <p class="text-17 font-semibold pb-3">{{ filter.title }}</p>

        <Select
            :options="contacts"
            valueKey="id"
            errorName="belongs_id"
            placeholder="Select contact"
            :searchEnabled="true"
            :canBeCleared="true"
            searchPlaceholder="Search contacts"
            v-model:value="contactId"
            @update:value="setContact"
            @searchKeyup="getContacts"
            @menuOpened="getContacts"
            @clear="
                () => {
                    contactId = null
                    contact = null
                    $emit('update', null)
                }
            "
        >
            <template #option="{ option, selected }">
                <div class="flex">
                    <div class="w-6 h-6 bg-red-600/20 mr-2 rounded-full flex items-center justify-center shrink-0 text-[9px] font-semibold shrink-0 text-center">
                        {{ selected ? contact.initals() : option.initals() }}
                    </div>

                    <div class="text-15 font-normal">{{ selected ? contact.fullName() : option.fullName() }}</div>
                </div>
            </template>
        </Select>

        <!-- <ContactView v-if='contact != null' :contact='contact'
			:preview='true'
			:yes='() => {
				updated();
				$refs.timeline.updated()
			}'
		/> -->
    </div>
</template>

<script>
import Contact from '~/models/contact.js'
import ContactView from '~/components/customer/blocks/contact-view.vue'

export default {
    props: {
        filter: Object,
        lContactId: [Number, String],
    },

    data() {
        return {
            contactId: null,
            contact: null,
            contacts: [],
        }
    },

    created() {
        this.getContacts().then((res) => {
            if (this.defaultBelongsType == 103) {
                this.dealId = this.defaultBelongsId
                // this.deal
            }

            if (this.defaultBelongsType == 102) {
                this.contactId = this.defaultBelongsId
                this.contact = this.contacts.find((c) => c.id == this.defaultBelongsId)
            }
        })
    },

    mounted() {},

    methods: {
        setContact(v) {
            this.contact = new Contact(this.contacts.find((c) => c.id == v))
            this.$emit('update', v)
        },

        getContacts(event = '') {
            return Promise.resolve(
                this.$axios
                    .get('/actions/contacts-search', {
                        params: {
                            search: event,
                        },
                    })
                    .then((res) => {
                        // this.contactId = null
                        // this.dealId = null
                        this.contacts = Contact.fill(res.contacts, {
                            vue: this,
                            $help: this.$help,
                        })

                        if (this.lContactId != null) {
                            this.contactId = this.lContactId
                            this.contact = new Contact(this.contacts.find((c) => c.id == this.lContactId))
                        }
                    }),
            )
        },
    },

    components: {
        ContactView,
    },
}
</script>
